import { FC, PropsWithChildren } from "react";

export const PushNotificationsProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
    return children;
}